import React from "react";

const SolarIcon = ({ size = 12, className = "text-yellow" }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 12 12"
      >
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6 9.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="m9.57 9.57-.065-.065m0-7.01.065-.065zM2.43 9.57l.065-.065zM6 1.04V1zM6 11v-.04zM1.04 6H1zM11 6h-.04zM2.495 2.495 2.43 2.43z"
        />
      </svg>
    </span>
  );
};

export default SolarIcon;
